module.exports = __webpack_public_path__ + "static/media/kimandboys88.9c348297.png";